export const setFlashError = (type, message) => {
  sessionStorage.setItem('type', type)
  sessionStorage.setItem('message', message)
}

export const showFlashMessage = () => {
  const type = sessionStorage.getItem('type')
  const message = sessionStorage.getItem('message')
  if (!type || !message) return

  displayFlashMessage(type, message)

  setTimeout(() => {
    sessionStorage.removeItem('type')
    sessionStorage.removeItem('message')
  }, 500)
}

const displayFlashMessage = (type, message) => {
  const alertHTML = `<p class="alert alert-${type}">${message}</p>`
  $('main').before(alertHTML)
}

export const showFailedMessage = () => {
  $('.alert-danger').html('ファイルを作成できませんでした。').show()
}
